export const sampleEvents = [
  // March Tuesdays - FRYS FREEROLL
  {
    id: 'march-tue-1',
    title: 'FRYS FREEROLL',
    date: '2025-03-04',
    time: '19:30',
    location: 'Poker Club'
  },
  {
    id: 'march-tue-2',
    title: 'FRYS FREEROLL',
    date: '2025-03-11',
    time: '19:30',
    location: 'Poker Club'
  },
  {
    id: 'march-tue-3',
    title: 'FRYS FREEROLL',
    date: '2025-03-18',
    time: '19:30',
    location: 'Poker Club'
  },
  {
    id: 'march-tue-4',
    title: 'FRYS FREEROLL',
    date: '2025-03-25',
    time: '19:30',
    location: 'Poker Club'
  },

  // March Thursdays - CONCEPT TURBO
  {
    id: 'march-thu-1',
    title: 'CONCEPT TURBO',
    date: '2025-03-06',
    time: '20:00',
    location: 'Poker Club'
  },
  {
    id: 'march-thu-2',
    title: 'CONCEPT TURBO',
    date: '2025-03-13',
    time: '20:00',
    location: 'Poker Club'
  },
  {
    id: 'march-thu-3',
    title: 'CONCEPT TURBO',
    date: '2025-03-20',
    time: '20:00',
    location: 'Poker Club'
  },
  {
    id: 'march-thu-4',
    title: 'CONCEPT TURBO',
    date: '2025-03-27',
    time: '20:00',
    location: 'Poker Club'
  }
]; 